/**
 * E-sign form submission handler
 * Stores customer info in sessionStorage before form submit for later use in checkout
 */

(function() {
  var form = document.getElementById('signer-form');
  if (!form) return;

  form.addEventListener('submit', function() {
    var signerName = document.getElementById('signer-name').value;
    var signerEmail = document.getElementById('signer-email').value;
    sessionStorage.setItem('customer_name', signerName);
    sessionStorage.setItem('customer_email', signerEmail);
    // Form will POST to server
  });
})();
